import SubmitSection from "../../../components/buttons/submitSection/SubmitSection";
import TitlePanel from "../../../components/captionTitle/CaptionTitle";

const LowContentLayout: React.FC<{
  title?: string;
  body: string | JSX.Element;
  hideSubmitSection?: boolean;
  hideSpaceAfterTitle?: boolean;
  onBackBtn?: (() => void) | undefined;
}> = (props) => {
  const { title: title, body, hideSpaceAfterTitle, onBackBtn } = props;
  return (
    <div className="d-flex flex-column h-100">
      {title && <TitlePanel text={title} />}
      {hideSpaceAfterTitle ? undefined : <div className="row spacer small" />}
      <div className="flex-grow-1 low-content-body bg-white p-3">
        {typeof body === "string" ? <p className="my-3 fs-3">{body}</p> : body}
      </div>
      {!props.hideSubmitSection && (
        <>
          <div className="row spacer" />
          <div className="low-content-layout-wrapper_left-container_submit-section">
            <div className="pt-4">
              <SubmitSection showApproveBtn={false} showCancelBtn={false} showBackBtn={true} onBack={onBackBtn} />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default LowContentLayout;
